const actionTypes = {
    ACCESS_TOKEN: "ACCESS_TOKEN",
    BUSINESS_STREAM: "BUSINESS_STREAM",
    USERINFO: 'USERINFO',
    MODAL_OPEN: 'MODAL_OPEN',
    GET_ALL_CENTER_LIST: 'GET_ALL_CENTER_LIST',
    GROUP_SESSION: 'GROUP_SESSION',
    RESET_GROUP_SESSION: 'RESET_GROUP_SESSION',
    LOADING: 'LOADING',
    GET_REPLACE_TEST_DATA: 'GET_REPLACE_TEST_DATA',
    CGS_TOTAL_CANDIDATES: 'CGS_TOTAL_CANDIDATES',
    CGS_TOTAL_CENTRE: 'CGS_TOTAL_CENTRE',
    LOADING_REPLACE_TEST: 'LOADING_REPLACE_TEST',
    SELECTED_CENTER_ID: 'SELECTED_CENTER_ID',
    IS_COMPONENT_RE_UPDATE_MCQ: 'IS_COMPONENT_RE_UPDATE_MCQ',
    TRANSFER_TO_GROUP_SESSION_DATA: 'TRANSFER_TO_GROUP_SESSION_DATA',
    INFO_SNACKBAR: 'INFO_SNACKBAR',
    SEARCH_LOADING: 'SEARCH_LOADING',
    IS_QUALIFICATION_RE_RENDERED_MCQ: 'IS_QUALIFICATION_RE_RENDERED_MCQ',
    IS_SERIES_RE_UPDATE_MCQ: 'IS_SERIES_RE_UPDATE_MCQ',
    ASSESSMENT_QUALIFICATION: 'ASSESSMENT_QUALIFICATION',
    QUALIFICATION_DROPDOWN_LIST: 'QUALIFICATION_DROPDOWN_LIST',
    CANDIDATE_DETAILS: 'CANDIDATE_DETAILS',
    TOTAL_CANDIDATE_LIST: 'TOTAL_CANDIDATE_LIST',
    SUMMARY_UI_TABLE_LIST_CANDIDATE: 'SUMMARY_UI_TABLE_LIST_CANDIDATE',
    SUMMARY_UI_TABLE_LIST_CENTER: 'SUMMARY_UI_TABLE_LIST_CENTER',
    SET_DEFAULT_VALUE: 'SET_DEFAULT_VALUE',
    TOTAL_CENTERS: 'TOTAL_CENTERS',
    FILTER_CGS_GROUP_SESSION: "FILTER_CGS_GROUP_SESSION",
    UPDATE_CLONE_DATA: 'UPDATE_CLONE_DATA',
    SEARCH_LIST_PAYLOAD: "SEARCH_LIST_PAYLOAD",
    SORTING_DATA: "SORTING_DATA",
    RESET_SEARCH_PAYLOAD_LIST: 'RESET_SEARCH_PAYLOAD_LIST',
    GET_ALL_BUSINESS_STREAM: 'GET_ALL_BUSINESS_STREAM',
    SET_API_ERROR: 'SET_API_ERROR',
    CENTER_DATA_DETAILS: 'CENTER_DATA_DETAILS',
    LOADING_SERIES_LIST: "LOADING_SERIES_LIST",
    GET_CGS_DETAILS: 'GET_CGS_DETAILS',
    GET_SERIES_DROPDOWN_LIST: 'GET_SERIES_DROPDOWN_LIST',
    GET_ASSESMENT_DROPDOWN_LIST: 'GET_ASSESMENT_DROPDOWN_LIST',
    GET_COMPONENT_DROPDOWN_LIST: 'GET_COMPONENT_DROPDOWN_LIST',
    ASSESMENT_RE_UPDATES: 'ASSESMENT_RE_UPDATES',
    RESET_DATA: 'RESET_DATA',
    IS_COMPONENT_RE_UPDATE: "IS_COMPONENT_RE_UPDATE",
    GET_TIME_ZONE_DROPDOWN_LIST: "GET_TIME_ZONE_DROPDOWN_LIST",
    RESET_SEARCH_RESULT_DROPDOWN: 'RESET_SEARCH_RESULT_DROPDOWN'
}

export default actionTypes;